import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import moment from 'moment/moment';

// COMPONENTS
import CardWrapper from '../CardWrapper';
import Loader from '../../common/Loader';

// MESSAGES
import HomeFormattedMessages from '../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../requests/DashboardRequest';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';

export default function Announcements({ errorHandler }) {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAnnouncements } = useDashboardRequest();

  const loadData = async () => {
    const response = await getAnnouncements(errorHandler);
    setAnnouncements(response);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <CardWrapper
      title={HomeFormattedMessages.announcements}
      enableTitleUnderline
      sx={{
        border: '2px solid',
        borderColor: 'secondary.light',
      }}
    >
      {loading ? (
        <Loader />
      ) : (
        <List disablePadding fullWidth>
          {announcements.map((item) => {
            return (
              <ListItem
                disableGutters
                fullWidth
                key={`announcement_${item.announcement_id}`}
              >
                <ListItemText
                    primary={item.announcement_message}
                    sx={item.start_date ? { width: '80%' } : { width: '100%' }}
                  />
                {item.start_date && <ListItemText
                  sx={{ width: '20%',color: 'grey.500', textAlign: 'right' }}
                  primary={
                    moment(
                      new Date(getZoneOffsettedDate(item.start_date)),
                    ).format('DD-MMM-YYYY')
                   }
                />}
              </ListItem>
            );
          })}
        </List>
      )}
    </CardWrapper>
  );
}
